<template>
  <media-content-wrapper
    :title="content.title"
    :description="content.description"
    :items="shownFiles"
    :emptyListMessage="'Nenhum arquivo cadastrado...'"
    :searchPlaceholder="'Buscar pelo nome do arquivo'">
    <template v-slot:content="slotProps">
      <file-card :file="slotProps.item"/>
    </template>
  </media-content-wrapper>
</template>

<script>
import MediaContentWrapper from '@/components/templates/MediaContentWrapper.vue';
import FileCard from './FileCard.vue';

export default {
  components: { FileCard, MediaContentWrapper },
  props: {
    content: Object,
  },
  computed: {
    shownFiles() {
      const filesCopy = this.content.files.slice();
      filesCopy.sort((a, b) => a.title.localeCompare(b.title));
      return filesCopy;
    },
  },
};
</script>
